import { useSections } from "@/contexts/classified";
import { useMemo } from "react";
/**
 * Hook to get the medium 1024 x 576 images
 *
 * @returns Medium images or null if no image
 */
export const useMediumImages = () => {
    var _a, _b;
    const images = (_b = (_a = useSections()) === null || _a === void 0 ? void 0 : _a.gallery) === null || _b === void 0 ? void 0 : _b.images;
    const mediumImages = useMemo(() => {
        if (!images || images.length < 1)
            return null;
        return images.map((image) => {
            if (!(image === null || image === void 0 ? void 0 : image.url))
                return image;
            const urlMedium = new URL(image.url);
            urlMedium.searchParams.set("w", "1024");
            urlMedium.searchParams.set("h", "576");
            return Object.assign(Object.assign({}, image), { id: image === null || image === void 0 ? void 0 : image.key, url: urlMedium.href });
        });
    }, [images]);
    return mediumImages;
};
